/**
 * R = responsive
 * S = static
 */
export enum ButtonSize {
  R_SMALL = 'r-small',
  R_MEDIUM = 'r-medium',
  R_LARGE = 'r-large',
  R_XLARGE = 'r-xlarge',
  S_SMALL = 's-small',
  S_MEDIUM = 's-medium',
  S_LARGE = 's-large',
  S_XLARGE = 's-xlarge',
}

export enum ButtonMode {
  FILL = 'fill',
  INLINE = 'inline',
  FILL_MOBILE = 'fill-mobile',
}

export enum ButtonTheme {
  PRIMARY_BLUE = 'primary-blue',
  PRIMARY_HEATHER = 'primary-heather',
  SECONDARY = 'secondary',
  SECONDARY_WHITE = 'secondary-white',
  TERTIARY = 'tertiary',
  TERTIARY_WHITE = 'tertiary-white',
}

export enum IconPosition {
  LEFT = 'left',
  RIGHT = 'right',
}

export enum ButtonType {
  SUBMIT = 'submit',
  BUTTON = 'button',
  MENU = 'menu',
  RESET = 'reset',
}
